<template>
  <div style="color:red">
    <div v-html="content"></div>
    <!-- <div>{{content}}</div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      content: null
    }
  },
  async mounted () {
    // let { data: res } = await this.$tkParse.get(`/classes/Docs/${'gSFGYaaE4Q'}`)
    // console.log('res', res)
    // this.content = res.content
    // console.log(typeof (this.content))
    // this.content = this.content.replace('<table>', '<table border="1">')

  }
}
</script>

<style>

</style>
